module.exports = __webpack_public_path__ + "static/img/table.2f028f80.svg";